import styled, { keyframes } from 'styled-components'

const expandWrapper = keyframes`
  0% { opacity: 0 }
  100% { opacity: 1 }
`

export const Container = styled.div`
  position: relative;
  width: 100%;
  height: 100%;

  @media (max-width: 768px) { width: 100vw !important; }
  @media (min-width: 768px) {
    background: ${p => p.expanded ? '#1D3739' : 'transparent'};
    display: flex;
    align-items: center;
  }
`
export const WrapperExpanded = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
  font-family: Amorim Sans, sans-serif;
  opacity: 0;

  animation: ${expandWrapper} .5s ease-out forwards;

  @media (min-width: 768px) {
    width: 95%;
    height: 100vh;
    min-height: 500px;
    margin: 0 auto;
  }
  @media (max-width: 768px) { width: 100vw !important; }
`

export const ContainerSVGMobile = styled.div`
overflow: ${p => p.mini ? 'hidden' : 'unset'};
position: fixed;
top: 0;
bottom: 0;
left: 0;
right: 0;
height: 100%;
width: 100%;
background: #1D3739;
svg {
    background: #1D3739;
    max-width: 200vw;
    max-height: 120vh;
    height: 100%;
  }
`
export const ContainerSVG = styled.div`
  display: flex;
  height: calc(100% - 100px);
  align-items: center;
  padding-top: 5%;
  svg{
    width: 100%;
    height: 100%;
  }
  @media (min-width: 768px) {
    min-width: 500px;
    height: 100vh;
    min-height: 400px;
    svg{
      width: 100%;
      height: 100%;
    }
  }
`
export const ContainerMenu = styled.div`
  position: absolute;
  width: 100%;
  display: flex;
  justify-content: center;
  height: 36px;
  bottom: 30px;
`

export const MenuFactoryShowRoom = styled.ul`
  position: relative;
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 300px;
  height: 36px;
  list-style: none;
`

export const ButtonFactoryShowroom = styled.li`
  
  &:not(.separator){
    color: #FFFFFF;
    font-family: 'Amorim Sans Book';
    text-transform: uppercase;
    font-size: 19px;
    cursor: pointer;
    opacity: .3;
    transition: all .3s linear;
    letter-spacing: .5px;
    &:hover {
    opacity: .6;
    }

    &.active {
      opacity: 1;
    }
  }
  
  &.separator {
    position: relative;
    width: 1px;
    height: 36px;
    &:after {
      position: absolute;
      content: '';
      width: 1px;
      background: #FFF;
      height: 36px;
      top: 0;
      left: 50%;
    }
  }
`

export const WrapperMini = styled.div`
  position: absolute;
  top: 60px;
  right: 4px;
  width: 314px;
  height: 200px;
  background: rgba(29, 55, 57, .7);
  transition: all .3s ease;
  cursor: pointer;
  opacity: 0;
  animation: ${expandWrapper} .5s ease-out forwards;

  &:hover {
    background: rgba(29, 55, 57, 1);

    .maximizar {
      &:after {
        transform: translate(9px, 9px);
        opacity: 1;
      }
    }
  }

  @media (min-width: 768px) {
    top: initial;
    left: initial;
    bottom: 46px;
    right: 60px;
  }
`
export const ContainerSVGMini = styled.div`
  display: flex;
  height: 90%;
  align-items: center;
  padding-top: 5%;
`

export const ButtonMaximizar = styled.div`
  position: absolute;
  left: 0;
  top: 0;
  width: 30px;
  height: 30px;
  font-size: 30px;

  &:after {
      position: absolute;
      content: '';
      top: 0;
      left: 0;
      opacity: 0;
      transform: translate(14px, 14px);
      width: 11px;
      height: 11px;
      border-top: solid 2px rgba(255,255,255, .6);
      border-left: solid 2px rgba(255,255,255, .6);
      transition: all .2s ease-out;
  }
`

